export default (function () { });
//# sourceMappingURL=noop.js.map